import MyContainer from "@/components/MyContainer";
import PickupForm from "@/pages/pickup/form/pickup-form";
import { useGetPickup } from "@/services/pickup-service";
import { Box } from "@mui/material";
import { useParams } from "wouter";

export function EditPickupPage() {
  const params = useParams();
  const pickupId = params.id?.toString();

  if (!pickupId) {
    return (
      <MyContainer title="Edit Pickup" subtitle="Edit pickup">
        <div>Pickup not found</div>
      </MyContainer>
    );
  }

  const { data: initialValues, isLoading } = useGetPickup(pickupId);

  if (isLoading) {
    return (
      <MyContainer title="Edit Pickup" subtitle="Edit pickup">
        <Box sx={{ p: 2, color: "text.secondary" }}>Loading…</Box>
      </MyContainer>
    );
  }

  if (!initialValues) {
    return (
      <MyContainer title="Edit Pickup" subtitle="Edit pickup">
        <Box sx={{ p: 2, color: "text.secondary" }}>Pickup not found</Box>
      </MyContainer>
    );
  }

  return (
    <MyContainer title="Edit Pickup" subtitle="Edit pickup">
      <PickupForm mode="update" initialValues={initialValues} />
    </MyContainer>
  );
}
